
import React from 'react';
import {Modal2} from "../modal";
import {Spinner} from "../../funcs/utils";
import {adminFullRebalance} from "./actions";

const is_taxable = (account_type) => {
  const taxable_accts = [
    "individual", "joint",
    "corporate", "partnership",
  ];
  return taxable_accts.includes(account_type);
}

const State = {
  PENDING: "PENDING",
  WORKING: "WORKING",
  ERROR: "ERROR",
  DONE: "DONE",
}



const show_acct = (component, account, index) => {

  let state_str;

  if (account.state === State.PENDING) {
    state_str = "Pending";
  } else if (account.state === State.WORKING) {
    state_str = (<Spinner/>);
  } else if (account.state === State.DONE) {
    state_str = (
      <span>
        Queue Id: { ' ' }
        <span style={{ fontWeight: "bold"}}>{account.queue_id}</span>
      </span>);
  } else {
    state_str = "UNKNOWN";
    console.log("Unknown state", account.state);
  }

  const taxable = is_taxable(account.account_type) ? "TAXABLE" : "NON-TAXABLE";
  return (
    <div key={index}>
      { index > 0 && <hr style={{ backgroundColor: "#000"}}/> }
      <div style={{display: "flex"}}>
        <div style={{flex: "1"}}>{account.name}</div>
        <div style={{flex: "1"}}>{account.account_number}</div>
      </div>
      <div style={{display: "flex"}}>
        <div style={{flex: "1"}}>{account.account_type}</div>
        <div style={{flex: "1"}}>{taxable}</div>
      </div>
      <div align={"center"}>{state_str}</div>
    </div>
  );
}

const DoStep = async (component, rebal_all, index) => {
  const token = component.props.token;
  const new_state = rebal_all;

  new_state[index].state = State.WORKING;
  component.setState({
    rebal_all: new_state,
  });

  const resp = (await adminFullRebalance(token, new_state[index].username, new_state[index].index));
  if (resp.status === "OK") {
    component.props.setUserRebalance(
      resp.payload.username, resp.payload.index, resp.payload.queue_item,
      resp.payload.category_to_etf, resp.payload.etf_to_category);
    new_state[index].state = State.DONE;
    new_state[index].queue_id = resp.payload.queue_item.id;
  } else {
    new_state[index].state = State.ERROR;
    console.log("Error", resp);
  }
  component.setState({
    rebal_all: new_state,
  })
  return {
    status: "OK",
  }

}

/**
 * @param accounts: {
 *   username: string,
 *   index: number,
 *   name: string,
 *   account_number: string,
 *   account_type: string}[];
 */
const RebalanceAllController = async (component, accounts) => {
  const rebal_all = accounts.map(account => {
    return {
      ...account,
      state: State.PENDING,
    }
  })
  component.setState({ rebal_all });
  const queue_ids = [];

  for(let i=0; i < accounts.length; i++) {
    await DoStep(component, rebal_all, i);
    if (rebal_all[i].state === State.DONE) {
      queue_ids.push(rebal_all[i].queue_id);
    }
  }

  return { status: "OK"};
}

const RebalanceAllDialog = props => {
  const { component } = props;
  const accts = component.state.rebal_all;
  let is_done = true;

  for(let i=0; i < accts.length; i++) {
    if (accts[i].state !== State.DONE) {
      is_done = false;
    }
  }

  const on_click = () => {
    if (!is_done) {
      return;
    }
    const queue_ids = [];
    for(let i=0; i < accts.length; i++) {
      if (accts[i].state === State.DONE) {
        queue_ids.push(accts[i].queue_id);
      }
    }
    console.log("nav to", queue_ids);
    component.setState({ rebal_all: null });

    if (queue_ids.length > 0) {
      component.props.navigatePath("/super-admin/rebalance", { ids: queue_ids.join(",") });
    }
  }

  const button_list = [
    {
      label: is_done ? "Done" : <Spinner/>,
      cb: on_click,
    }
  ]

  return (
    <Modal2
      header={"Rebalance All"}
      buttonList={button_list}>
      <div>
        { accts.map((account, index) => show_acct(component, account, index))}
      </div>
    </Modal2>
  )

}

export { RebalanceAllDialog, RebalanceAllController };
